import { render } from "./new_page.vue?vue&type=template&id=e9acfc0a&lang=pug"
import script from "./new_page.vue?vue&type=script&lang=js"
export * from "./new_page.vue?vue&type=script&lang=js"

import "./new_page.vue?vue&type=style&index=0&id=e9acfc0a&lang=scss"

import exportComponent from "/var/www/hash_pick/releases/20261030073843/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__